export default __webpack_public_path__ + "static/media/christmas-scroll.7b5b13ff.png";